import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import type { ReportContext } from '../../shared/types';
import { WIRE_REPORT_TYPE } from '../../shared/wireReportType';

export function useReportAbuseTracking(reportContext: ReportContext): (context: { success: boolean }) => void {
	const track = useTracking();

	return useCallback(
		({ success }) => {
			switch (reportContext.type) {
				case 'petition':
					void track('petition_report_abuse', {
						petition_id: reportContext.petitionId,
						successful: success,
						experiment_variation: 'control',
					});
					return undefined;
				case 'petitionSupporterComment':
					void track('supporter_comment_report_abuse', {
						comment_id: reportContext.contentId,
						likes: reportContext.trackingData.likeCount,
						role: WIRE_REPORT_TYPE.petitionSupporterComment,
						petition_id: reportContext.petitionId,
						report_abuse_location: reportContext.trackingData.location,
						successful: success,
					});
					return undefined;
				case 'petitionSupporterVideo':
					void track('video_comment_report_abuse', {
						comment_id: reportContext.contentId,
						likes: reportContext.trackingData.likeCount,
						role: WIRE_REPORT_TYPE.petitionSupporterVideo,
						petition_id: reportContext.petitionId,
						report_abuse_location: reportContext.trackingData.location,
						successful: success,
					});
					return undefined;
				default:
					return undefined;
			}
		},
		[track, reportContext],
	);
}
